export default __webpack_public_path__ + "static/media/mobile_1.fd14ba0c.png";